/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IFooterViewProps } from './footer-item';

/**
 *
 * FooterItemView component.
 * @extends {React.PureComponent<IFooterViewProps>}
 */
export class FooterItemView extends React.PureComponent<IFooterViewProps> {
    public render(): JSX.Element | null {
        const { FooterItem } = this.props;
        return <Module {...FooterItem}>{this._renderElement(this.props)}</Module>;
    }

    private _renderElement(props: IFooterViewProps): React.ReactNode | null {
        const { heading, HeadingContainer, Link, linkText, image, text, EditableLink } = props;
        if (heading) {
            return <Node {...HeadingContainer}> {heading} </Node>;
        } else if (Link && image) {
            return (
                <Node {...Link}>
                    {linkText}
                    {image}
                </Node>
            );
        } else if (Link) {
            return EditableLink;
        }
        return (
            <>
                {text}
                {image}
            </>
        );
    }
}

export default FooterItemView;
